import { render, staticRenderFns } from "./DropzoneImageFied.vue?vue&type=template&id=f9a895f2&scoped=true"
import script from "./DropzoneImageFied.vue?vue&type=script&lang=js"
export * from "./DropzoneImageFied.vue?vue&type=script&lang=js"
import style0 from "./DropzoneImageFied.vue?vue&type=style&index=0&id=f9a895f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a895f2",
  null
  
)

export default component.exports